/**
 * The one place a canonical deliverable state is mapped to its terminology key.
 *
 * `DeliverableState` is the workbook's spelling ("Manuscript"); `StateTermKey`
 * is the lower-case key the terminology set is stored under ("manuscript").
 * They are deliberately different types — one is a workbook value on a published
 * contract, the other a display lookup — and this function is the only bridge,
 * so nothing anywhere else lower-cases a state and hopes.
 */
import { STATE_ORDER, type DeliverableState, type StateTermKey } from '@blueprint/shared';

const KEYS: Record<DeliverableState, StateTermKey> = {
  Draft: 'draft',
  Manuscript: 'manuscript',
  Proof: 'proof',
  Published: 'published',
};

export function stateTermKey(state: DeliverableState): StateTermKey {
  return KEYS[state];
}

/** Canonical cycle order, re-exported so the legend and Phase 3 agree on it. */
export const STATES = STATE_ORDER;
